/*========================================
        Imports!!!
=========================================*/

/*--BrowserRouter--*/

import { Link, useNavigate } from 'react-router';
import { useState } from 'react';


/*--css--*/
import '../assets/css/sticks.css';
import '../assets/css/staticElements.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

/*--img in content--*/

import paluszek1 from '../assets/paluszki/lower/ezerek_mak.webp';
import paluszek2 from '../assets/paluszki/lower/ezerki_papryka.webp';
import paluszek3 from '../assets/paluszki/lower/ezerki_sezamowe.webp';
import paluszek4 from '../assets/paluszki/lower/orkiszowe_lnine.webp';
import paluszek5 from '../assets/paluszki/lower/orkiszowe_mak.webp';
import paluszek6 from '../assets/paluszki/lower/orkiszowe_naturalne.webp';
import paluszek7 from '../assets/paluszki/lower/orkiszowe_solone.webp';
import paluszek8 from '../assets/paluszki/lower/pszenne_sezamowe.webp';
import paluszek9 from '../assets/paluszki/lower/pszenne_sezamowe.webp';
import paluszek10 from '../assets/paluszki/lower/pszenne_soolone.webp';
import paluszek11 from '../assets/paluszki/lower/siemie_lnianne.webp';


/*--cows footer--*/

import mu1 from '../assets/cowsss/lower/3.webp';
import mu2 from '../assets/cowsss/lower/5.webp';
import mu3 from '../assets/cowsss/lower/6.webp';
import mu4 from '../assets/cowsss/lower/7.webp';
import mu5 from '../assets/cowsss/lower/4.webp';
import mu6 from '../assets/cowsss/lower/1.webp';
import social2 from '../assets/icons/phone.webp';
import social3 from '../assets/icons/insta.webp';

/*--logo--*/
import logo from '../assets/img/logo.webp';

/*--high--*/

/*--img in content--*/

import paluszek6h from '../assets/paluszki/higher/orkiszowe_naturalne.webp';
import paluszek7h from '../assets/paluszki/higher/orkiszowe_solone.webp';
import paluszek8h from '../assets/paluszki/higher/pszenne_sezamowe.webp';
import paluszek9h from '../assets/paluszki/higher/pszenne_sezamowe.webp';
import paluszek10h from '../assets/paluszki/higher/pszenne_soolone.webp';
import paluszek11h from '../assets/paluszki/higher/siemie_lnianne.webp';

/*--cows footer--*/

import mu1h from '../assets/cowsss/higher/3.webp';
import mu2h from '../assets/cowsss/higher/5.webp';
import mu3h from '../assets/cowsss/higher/6.webp';
import mu4h from '../assets/cowsss/higher/7.webp';
import mu5h from '../assets/cowsss/higher/4.webp';
import mu6h from '../assets/cowsss/higher/1.webp';

/*========================================
        Functions!!!
=========================================*/
function LinkToContact() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
    navigate('/#Contact');
  };

  return (
    <button onClick={handleClick}>O nas</button>
  );
}

function LinkToProducts() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
    navigate('/#Products');
  };

  return (
    <button onClick={handleClick}>Produkty</button>
  );
}

/*========================================
        Header!!!
=========================================*/

function Header(){
  return (
    <>
    {/*====Header====*/}
    <header>
      <Row className='p-4'>
        {/*----Logo----*/}
        <Col xl={8} lg={7} md={6}>
          <div className='Logo'>
              <Link to="/" reloadDocument={true}>
                <Row>
                  <Col lg={1} md={2} xs={2} className='log'>
                    <img src={logo} alt='logo' />
                  </Col>
                  <Col  lg={10} md={9} xs={9} className='log textlog'>
                    Beskidzkie Stado
                  </Col>
                </Row>
              </Link>
          </div>
        </Col>
        {/*----Tabs----*/}
        <Col xl={4} lg={5} md={6} className='log'>
          <Row className='Tabs'>
            <Col lg={3} md={3} xs={3} className='Tcol'>
              <a href='#About' >
                <LinkToContact />
              </a>
            </Col>
            <Col lg={3} md={3} xs={3} className='Tcol'>
              <a href='#Products'>
                <LinkToProducts />
              </a>
            </Col>
            <Col lg={3} md={3} xs={3} className='Tcol'>
              <a href='#Contact'>
                <button >Kontakt</button>
              </a>
            </Col>
            <Col lg={3} md={3} xs={3} className='Tcol'>
                <Link to="/blog" reloadDocument = {true}>
                  <button >Blog</button>
                </Link>
            </Col>
          </Row>
        </Col>
      </Row>
      </header >
    </>
  );
}


/*========================================
        Middle!!!
=========================================*/

function Middle({Changing6}) {
    return (
        <>
        <section className='Middle'>
            {/*--stick publicity--*/}
            <section className='publicity'>
                <Row className='publicity_Row'>
                    {/*--text--*/}
                    <Col lg={5} md={12} sm={12} className='p-1 describe'>
                        <h1>Paluszki pełnozbożowe</h1>
                        <h5>
                            Pyszna i pełnowartościowa przekąska, która łączy zdrowie z przyjemnością chrupania. Nasze paluszki zostały stworzone z naturalnych, pełnoziarnistych składników i dokładnie przebadane pod kątem alergenów tak,
                            aby były bezpieczne dla każdego, niezależnie od wieku. Idealne do lunchboxa, na spacer, do szkoły czy pracy. Wybierz swój ulubiony smak i ciesz się zdrową przekąską zawsze, gdy masz ochotę!
                        </h5>
                    </Col>
                    {/*--img--*/}
                    <Col lg={6} md={12} sm={12} className='lg-p-3 xs-p-1'>
                        <div className="stick-image-container"/>
                    </Col >
                </Row>
                {/*--choose the stick--*/}
                <section className='ChooseYour'>
                    <Row className='StickRow'>
                        <Col className='plauszek'>
                            <img onLoad={Changing6} src={paluszek1} alt="paluszek" id="paluszek1"/>
                            <span>Paluszki orkiszowe z makiem</span>
                        </Col>
                        <Col className='plauszek'>
                            <img onLoad={Changing6} src={ paluszek2} alt="paluszek" id="paluszek2"/>
                            <span>Paluszki orkiszowe z papryką</span>
                        </Col>
                        <Col className='plauszek'>
                            <img onLoad={Changing6} src={paluszek3} alt="paluszek" id="paluszek3"/>
                            <span>Paluszki grahamowe z sezamem</span>
                        </Col>
                    </Row> 
                    <Row className='StickRow'>
                        <Col className='plauszek'>
                            <img onLoad={Changing6} src={paluszek4} alt="paluszek" id="paluszek4"/>
                            <span>Paluszki orkiszowe z siemieniem lnianym</span>
                        </Col>
                        <Col className='plauszek'>
                            <img onLoad={Changing6} src={paluszek5} alt="paluszek" id="paluszek5"/>
                            <span>Paluszki orkiszowe z makiem</span>
                        </Col>
                        <Col className='plauszek'>
                            <img onLoad={Changing6} src={ paluszek11} alt="paluszek" id="paluszek11"/>
                            <span>Paluszki chlebowe orkiszowe z siemieniem lnianym</span>
                        </Col>
                    </Row> 
                    <Row className='StickRow'>
                        <Col className=' plauszek'>
                            <img onLoad={Changing6} src={ paluszek10} alt="paluszek" id="paluszek10"/>
                            <span>Paluszki pszenne solone</span>
                        </Col>
                        <Col className='plauszek'>
                            <img onLoad={Changing6} src={paluszek8 } alt="paluszek" id="paluszek8"/>
                            <span>Paluszki pszenne sezamowe</span>
                        </Col>
                        <Col className='plauszek'>
                            <img onLoad={Changing6} src={paluszek9} alt="paluszek" id="paluszek9"/>
                            <span>Paluszki pszenne sezamowe</span>
                        </Col>
                    </Row> 
                    <Row className='StickRow'>
                        <Col className='plauszek'>
                            <img onLoad={Changing6} src={paluszek7 } alt="paluszek" id="paluszek7"/>
                            <span>Paluszki orkiszowe solone</span>
                        </Col>
                        <Col className='plauszek'>
                            <img onLoad={Changing6} src={ paluszek6} alt="paluszek" id="paluszek6"/>
                            <span>Paluszki orkiszowe z topinamburem</span>
                        </Col>
                    </Row> 
                </section>
            </section>
          </section>
        </>
    );
}



/*========------------========*/
/*========------------========*/
/*------Footer------*/
/*========------------========*/
/*========------------========*/

function Footer({Changing6}) {
  return (
    <>
      <section className='footer'>
        <Row className='MiniGallery'>
          {/*-short gallery-*/}
          <Col lg={6} md={12} xs={12} className='mincol'>
            <section className='stadko'>
              {/*-logo-*/}
              <div className='FooterLogo'>
                <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                  <Row>
                    <Col lg={2} md={1} xs={2} className='logoFooter'>
                      <p>
                        <img src={logo} alt='logo' />
                      </p>
                    </Col>
                    <Col lg={10} md={11} xs={10} className='logoFooter'>
                      <h2>Beskidzkie Stado</h2>
                    </Col>
                  </Row>
                </a>
              </div>
              {/*-photos-*/}
              <div className='smallGallery'>
                <Row>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing6} src={mu6} alt="Cow" id="mu6"/>
                    </a>  
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing6} src={mu4} alt="Cow" id="mu4"/>
                    </a>
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing6} src={mu3} alt="Cow" id="mu3"/>
                    </a>
                  </Col>
                </Row>
                <Row className='tooff'>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing6} src={mu2} alt="Cow" id="mu2"/>
                    </a>
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing6} src={mu5} alt="Cow" id="mu5"/>
                    </a>
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing6} src={mu1} alt="Cow" id="mu1"/>
                    </a>
                  </Col>
                </Row>
              </div>
            </section>
          </Col>
          {/*-Contact-*/}
          <Col lg={6} md={12} xs={12}  className='mincol'>
              <section className='contact' id='Contact'>
                <div>
                  <h2>Kontakt</h2>
                </div>
                <section className='links'>
                  {/*-phone-*/}
                  <Row className='package'>
                    <Col lg={2} md={12} xs={12} className='Colek'>
                      <a href='tel:+48 532 233 916'>
                        <img src={social2} alt="socialek" loading="lazy" />
                      </a>
                    </Col>
                    <Col lg={9} md={12} xs={12} className='Colek'>
                      <span>+48 532 233 916</span>
                    </Col>
                  </Row>
                  {/*-instagram-*/}
                  <Row className='package'>
                    <Col lg={2} md={12} xs={12} className='Colek'>
                      <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                        <img src={social3} alt="socialek" loading="lazy" />
                      </a>
                    </Col>
                    <Col lg={9} md={12} xs={12} className='Colek'>
                      <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                        <span>Beskidzkie_stado</span>
                      </a>
                    </Col>
                  </Row>
                </section>
            </section>
          </Col>
        </Row>
        {/*-Copyright-*/}
        <Row>
          <Col lg={12} md={12} xs={12} className='copyright'>
            <div className='copya'>All rights reserved. Created by <a href="https://pixelpick.pl"> PixelPick</a></div>
          </Col>
        </Row>
      </section>
    </>
  );
}





function Sticks() {

  const [loadedCount6, setLoadedCount6] = useState(null);

  const Changing6 = () => {
    setLoadedCount6(prev => {
      const NewCount6 = prev + 1;
      if (NewCount6 === 15) {
        setTimeout(() => {
          console.log("Iaam loading better quality photos now");
  
          const swap = (id, src) => {
            const el = document.getElementById(id);
            if (el) el.src = src;
            else console.warn(`${id} not found in DOM`);
          };
  
          swap("paluszek6", paluszek6h);
          swap("paluszek7", paluszek7h);
          swap("paluszek8", paluszek8h);
          swap("paluszek9", paluszek9h);
          swap("paluszek10", paluszek10h);
          swap("paluszek11", paluszek11h);
          swap("mu1", mu1h);
          swap("mu2", mu2h);
          swap("mu3", mu3h);
          swap("mu4", mu4h);
          swap("mu5", mu5h);
          swap("mu6", mu6h);
  
        }, 2000);
        console.log(loadedCount6);
      }
      return NewCount6;
    });
  };

    return (
        <>
          <Header />
          <Middle Changing6={Changing6} />
          <Footer Changing6={Changing6} />
        </>
    );
}

export default Sticks;